import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Card, btn, inputCls } from "@/components/common/Ornament";

export default function SecurityTab() {
  const [f, setF] = useState({ current_admin_passcode: "", new_viewer_password: "", new_admin_passcode: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = { current_admin_passcode: f.current_admin_passcode, new_viewer_password: f.new_viewer_password || null, new_admin_passcode: f.new_admin_passcode || null };
      const { data } = await api.put("/admin/credentials", body);
      toast.success(`Updated: ${data.changed.join(" & ")}. Other sessions for that role were signed out.`);
      setF({ current_admin_passcode: "", new_viewer_password: "", new_admin_passcode: "" });
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Card eyebrow="Access Control" title="Change Passwords" testId="admin-security">
      <form onSubmit={save} className="max-w-lg space-y-4">
        <p className="text-sm text-slate-600">Passwords are stored as secure hashes. Leave a field blank to keep it unchanged. Minimum 8 characters.</p>
        <label className="block"><span className="text-xs font-semibold text-[#3E5C4E]">Current admin passcode (required)</span>
          <input type="password" value={f.current_admin_passcode} onChange={set("current_admin_passcode")} className={inputCls + " mt-1"} autoComplete="current-password" data-testid="admin-current-passcode-input" /></label>
        <label className="block"><span className="text-xs font-semibold text-[#3E5C4E]">New viewer password</span>
          <input type="password" value={f.new_viewer_password} onChange={set("new_viewer_password")} className={inputCls + " mt-1"} autoComplete="new-password" data-testid="admin-new-viewer-password-input" /></label>
        <label className="block"><span className="text-xs font-semibold text-[#3E5C4E]">New admin passcode</span>
          <input type="password" value={f.new_admin_passcode} onChange={set("new_admin_passcode")} className={inputCls + " mt-1"} autoComplete="new-password" data-testid="admin-new-admin-passcode-input" /></label>
        <button type="submit" disabled={busy || !f.current_admin_passcode || (!f.new_viewer_password && !f.new_admin_passcode)} className={btn.gold} data-testid="admin-change-passwords-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Update passwords
        </button>
      </form>
    </Card>
  );
}
